module.exports = __webpack_public_path__ + "assets/svg/Icons/32/task-red-a858de.svg";